import React, { useEffect, useState } from "react";
import { AlertTriangle, Info, X } from "lucide-react";
import { api } from "../lib/api";

export default function ServiceStatusBanner({ role }) {
    const normalizedRole = String(role || "").toLowerCase();
    const [items, setItems] = useState([]);
    const [dismissed, setDismissed] = useState({});

    useEffect(() => {
        if (["admin", "investor"].includes(normalizedRole)) return undefined;
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get("/service-status");
                if (alive) setItems(Array.isArray(data?.items) ? data.items : []);
            } catch {
                // Yon banner pa dwe janm bloke itilizasyon sit la si endpoint la echwe.
            }
        };
        load();
        const timer = setInterval(() => {
            if (document.visibilityState === "visible") load();
        }, 30000);
        return () => { alive = false; clearInterval(timer); };
    }, [normalizedRole]);

    if (["admin", "investor"].includes(normalizedRole)) return null;
    const visible = items.filter((item) => !dismissed[`${item.key}:${item.updatedAt || item.message}`]);
    if (!visible.length) return null;

    return (
        <div className="fixed left-1/2 top-3 z-[90] w-[min(94vw,780px)] -translate-x-1/2 space-y-2">
            {visible.slice(0, 3).map((item) => {
                const id = `${item.key}:${item.updatedAt || item.message}`;
                const outage = String(item.level || "").toUpperCase() === "OUTAGE" || item.blockOperations;
                return (
                    <div key={id} className={`flex items-start gap-3 rounded-2xl border px-4 py-3 shadow-2xl backdrop-blur-xl ${outage ? "border-red-300/25 bg-[#2a1015]/95 text-red-50" : "border-amber-300/25 bg-[#2a2110]/95 text-amber-50"}`}>
                        {outage ? <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" /> : <Info className="mt-0.5 h-5 w-5 shrink-0" />}
                        <div className="min-w-0 flex-1">
                            <div className="text-xs font-black">{item.label || "MKTRANSFE"}</div>
                            <div className="mt-0.5 text-xs leading-5 opacity-90">{item.message}</div>
                        </div>
                        <button type="button" onClick={() => setDismissed((prev) => ({ ...prev, [id]: true }))} className="grid h-7 w-7 shrink-0 place-items-center rounded-lg border border-white/10 bg-white/[0.05] opacity-70 hover:opacity-100" aria-label="Fèmen mesaj"><X className="h-3.5 w-3.5" /></button>
                    </div>
                );
            })}
        </div>
    );
}
